export const config = {
  // algorithm: [theme.darkAlgorithm, theme.compactAlgorithm],
  token: {
    colorPrimary: "#17549a",
    colorDanger: "red",
    fontSize: 16,
    padding: 18,
  },
  components: {
    Radio: {
      colorPrimary: "#00b96b",
    },
  },
};
